module.exports = __webpack_public_path__ + "img/GP2_Austria.5c854640.png";